<template>
  <BtnToggle 
    :class="{ active: active }"
    :title="$t('engine.manageText.modalWidget.tooltip.lblItalic', languageEngine)"
    @click="onClick(!value)"
  >
    <i class="far fa-italic fs-16"></i>
  </BtnToggle>
</template>

<script>
import { mapGetters } from "vuex";
import BtnToggle from "./_BtnToggle";

export default {
  components: {
    BtnToggle,
  },
  props: {},
  data() {
    return {
      active: false,
    }
  },
  computed: {
    ...mapGetters({
      languageEngine: "designIframe/userPreference/languageEngine",
      texteditor: "designIframe/texteditor/texteditor",
    }),
    selectionFormatTemplate() {
      return this.texteditor.selectionFormatTemplate;
    },
    selectionFormatMerge() {
      return this.texteditor.selectionFormatMerge;
    },
    value() {
      if (this.selectionFormatMerge.fontStyle == 'unset') return false;
      if (this.selectionFormatMerge.fontStyle == 'normal') return false;
      if (this.selectionFormatMerge.fontStyle == 'italic') return true;
      return Boolean(this.selectionFormatMerge.italic);
    },
  },
  methods: {
    onClick(value) {
      this.active = !this.active;

      if (value) {
        this.texteditor.editor.format("italic", true);
        this.texteditor.editor.format("fontStyle", false);
      } else if (!value && this.selectionFormatTemplate.fontStyle == 'italic') {
        this.texteditor.editor.format("italic", false);
        this.texteditor.editor.format("fontStyle", 'normal');
      } else {
        this.texteditor.editor.format("italic", false);
        // this.texteditor.editor.format("fontStyle", false);
        this.texteditor.editor.format("fontStyle", 'normal');
      }
    }
  },
  mounted() {
    this.active = this.value;
  },
  watch: {
    value() {
      this.active = this.value;
    }
  },
}
</script>
